function LicensingDetails({ entity, licenseDetails }) {
    const rows = [
        { label: "Data de expiração da licença", total: licenseDetails?.expirationDateLicenseUTC ?? "-", used: null, colSpan: true },
        { label: "Limite de câmeras de OCR ativas", total: licenseDetails?.maxLanesActive ?? "-", used: licenseDetails?.lanes_total },
        { label: "Limite de core de processamento", total: licenseDetails?.maxCoreProcessingOCR ?? "-", used: "" },
        { label: "Limite de acessos simultâneos (SentryView e Área Web)", total: licenseDetails?.usersConnections ?? "-", used: licenseDetails?.users_total ?? "-" },
        { label: "Limite de dispositivos móveis ativos", total: licenseDetails?.limitDevices ?? "-", used: licenseDetails?.devices_total ?? "-" },
        { label: "Limite de centrais de alarme", total: licenseDetails?.limitContactId ?? "-", used: licenseDetails?.limitContactIdTotal ?? "-" },
        { label: "Modalidade", total: licenseDetails?.app_modality ?? "-", used: null, colSpan: true },
    ];

    const showTotalActiveLane = !!licenseDetails?.totalActiveLane;

    return (
        <div className="flex justify-center">
            <div className="w-[60%] border border-neutral-200 p-3 print:w-full">
                <h2 className="text-center mt-4">
                    SENTRY <strong>{licenseDetails?.versionLicense ?? ""}</strong>
                </h2>
                <h5 className="text-center mt-1">
                    <span className="text-[14px]">Licença emitida em nome de: {entity?.name ?? "-"}</span>
                </h5>
                <h5 className="text-center mt-1">
                    <span className="text-[14px]">Versão: {licenseDetails?.implementationVersion ?? "-"}</span>
                </h5>
                <h5 className="text-center mt-1">
                    <span className="text-[14px]">ID: {licenseDetails?.sinpass ?? "-"}</span>
                </h5>

                <table className="w-full mt-3 border border-neutral-200">
                    <thead>
                        <tr className="border-b border-neutral-200 text-black">
                            <th className="text-left p-2"> </th>
                            <th className="text-center p-2">Total</th>
                            <th className="text-center p-2">Em uso</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-neutral-200 text-sm">
                        {rows.map((r) => (
                            <tr key={r.label} className={"odd:bg-zinc-50 odd:text-neutral-600 even:bg-white even:text-neutral-900"}>
                                <td className="text-left p-2">{r.label}</td>

                                {r.colSpan ? (
                                    <td colSpan={2} className="text-center p-2">{r.total}</td>
                                ) : (
                                    <>
                                        <td className="text-center p-2">{r.total}</td>
                                        <td className="text-center p-2">{r.used}</td>
                                    </>
                                )}
                            </tr>
                        ))}

                        {showTotalActiveLane && (
                            <tr className="odd:bg-zinc-50 even:bg-white">
                                <td className="text-left p-2">Total de faixas ativas</td>
                                <td colSpan={2} className="text-center p-2">
                                    {licenseDetails.totalActiveLane}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default LicensingDetails;